import { call, put, takeLatest } from 'redux-saga/effects';

import { getMovementReportData } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getMovementReportData, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* movementReportListSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
